import React from "react";
import { createRoot } from "react-dom/client";
import { ConfirmationPopCustom } from "components/Modals/ConfirmationPop";

// Function to trigger confirmation dialog
const confirmDialog = (props) => {
  return new Promise((resolve, reject) => {
    const modalContainer = document.createElement("div");
    document.body.appendChild(modalContainer);

    const root = createRoot(modalContainer);

    const handleConfirm = () => {
      root.unmount();
      document.body.removeChild(modalContainer);
      resolve(true);
    };

    const handleCancel = () => {
      root.unmount();
      document.body.removeChild(modalContainer);
      resolve(false);
    };

    root.render(
      <ConfirmationPopCustom
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        {...props}
      />
    );
  });
};

export default confirmDialog;
